import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  SaveableReadingIntention,
  SaveableStudyNote,
} from '®shared/annotations';

export const STATE_USER_ANNOTATIONS = 'userAnnotations';

export type StudyNotesByResourceId = {
  [resourceId: string]: SaveableStudyNote;
};
export type ReadingIntentionsByResourceId = {
  [resourceId: string]: SaveableReadingIntention;
};
export type ListsLoaded = { [listId: string]: boolean };

export interface UserAnnotationsState {
  studyNotesByUserAndResource: { [userId: string]: StudyNotesByResourceId };
  readingIntentionsByUserAndResource: {
    [userId: string]: ReadingIntentionsByResourceId;
  };
  listsLoadedByUser: { [userId: string]: ListsLoaded };
}

export const USER_ANNOTATIONS_INITIAL_STATE: UserAnnotationsState = {
  studyNotesByUserAndResource: {},
  readingIntentionsByUserAndResource: {},
  listsLoadedByUser: {},
};

const selectUserAnnotationsState = createFeatureSelector<UserAnnotationsState>(
  STATE_USER_ANNOTATIONS,
);

export const areUserAnnotationsLoadedForList = (
  userId: string,
  listId: string,
) =>
  createSelector(selectUserAnnotationsState, state =>
    (state.listsLoadedByUser[userId] || {})[listId] ? true : false,
  );

export const selectStudyNotesByResourceForUser = (userId: string | null) =>
  createSelector(
    selectUserAnnotationsState,
    state => (userId && state.studyNotesByUserAndResource[userId]) || {},
  );

export const selectStudyNoteForUserAndResource = (
  userId: string,
  resourceId: string,
) =>
  createSelector(
    selectStudyNotesByResourceForUser(userId),
    state => state[resourceId],
  );

export const selectReadingIntentionsByResourceForUser = (
  userId: string | null,
) =>
  createSelector(
    selectUserAnnotationsState,
    state => (userId && state.readingIntentionsByUserAndResource[userId]) || {},
  );

export const selectReadingIntentionForUserAndResource = (
  userId: string,
  resourceId: string,
) =>
  createSelector(
    selectReadingIntentionsByResourceForUser(userId),
    state => state[resourceId],
  );

export function getInitialUserAnnotationsState(): UserAnnotationsState {
  return USER_ANNOTATIONS_INITIAL_STATE;
}
